import { css, html, LitElement } from "lit"
import "@luminecence/composants/BoutonIcone"
import "./ListePokemons.js"

export const EVENEMENT_MODIFIER_AMI = "evenementModifierAmi",
  EVENEMENT_AJOUTER_MESSAGE_A_UNE_CONVERSATION = "evenementAjouterMessageAUneConversation"

export default class Ami extends LitElement {
  static properties = {
    nom: { type: String },
    echanges: { type: Array },
    commentaire: { type: String },
    estModeAmis: { type: Boolean },
    panneauAmiDeplier: { type: Boolean, state: true },
  }

  static styles = css`

    :host {
      display: flex;
      flex-direction: column;
      gap: 1rem;
    }

    .conteneur {
        background-color: var(--couleur-300);
        font-size: 2.5rem;
        padding: 1rem;
        display: flex;
        flex-direction: column;
        gap: 2rem;
        border-radius: 1rem;
        cursor: pointer;
      touch-action: manipulation;
    }

    .accordeon {
        transition: transform 0.3s ease;
    }

    .accordeon_fermer {
        transform: rotate(180deg);
    }

    .entete {
        display:flex;
        align-items: center;
    }

    .separateur {
        content: "";
        display: block;
        height: 2px;
        width: 100%;
        border-radius: 3px;
        background: linear-gradient(
            90deg,
            transparent 0%,
            var(--couleur-texte) 50%,
            transparent 100%
        );
    }

    .entete .nom {
        padding-left: 1rem;
    }

    .accordeon {
        width: 1.6rem;
        height: 1.6rem;
        background-color: var(--couleur-texte);
        transition: transform 0.3s;
        display: inline-block;
        mask: url('../images/accordeon.svg') no-repeat center;
        -webkit-mask: url('../images/accordeon.svg') no-repeat center;
    }

    .accordeon_ouvrir {
        transform: rotate(0deg);
    }

    .accordeon_fermer {
        transform: rotate(180deg);
    }

    .commentaire {
        font-size: 1.5rem;
    }

    .actions {
        display:flex;
        flex: 1;
        justify-content: flex-end;
    }

    p-bouton-icone {
        display: inline-flex;
    }

    .liste {
      display: grid;
      grid-template-rows: 1fr;
      opacity: 1;
      transition: grid-template-rows 0.35s cubic-bezier(.4,0,.2,1), opacity 0.25s ease;
    }

    .liste_fermee {
      grid-template-rows: 0fr;
      opacity: 0;
      pointer-events: none;
    }

    .liste_contenu {
      min-height: 0;
      overflow: hidden;
    }
    `

  id = ""

  constructor() {
    super()
    this.nom = ""
    this.echanges = []
    this.commentaire = ""
    this.estModeAmis = true
    this.panneauAmiDeplier = true
  }

  render() {
    return html`
      <div
        class="conteneur"
        role="button"
        aria-expanded="${this.panneauAmiDeplier ? "true" : "false"}"
        aria-label="${this.panneauAmiDeplier ? "Fermer les échanges avec " : "Ouvrir les échanges avec "}${this.nom}"
        tabindex="0"
        @pointerup=${this.modifierAffichageAccordeon}
        @keydown=${this.gererClavierAccordeon}
      >
            <div class="entete">
                <span class="accordeon ${this.panneauAmiDeplier ? "accordeon_ouvrir" : "accordeon_fermer"}"></span>
                <span class="nom">${this.nom}</span>
                <div class="actions">
                ${
                  this.estModeAmis
                    ? html`
                    <p-bouton-icone icone="ajouter_message" @click=${this.ajouterMessage}></p-bouton-icone>
                  <p-bouton-icone icone="note" @click=${this.modifierAmi}></p-bouton-icone>`
                    : ""
                }
                </div>
            </div>
            
            ${
              this.commentaire
                ? html`
                <div class="separateur"></div> 
                <span class="commentaire">${this.commentaire}</span>`
                : ""
            }
    </div>
    <div class="liste ${this.panneauAmiDeplier ? "" : "liste_fermee"}">
      <div class="liste_contenu">
        <p-liste-pokemons .listePokemons=${this.echanges} .ami=${this.id}></p-liste-pokemons>
      </div>
    </div>`
  }

  /**
   * @param {KeyboardEvent} event
   */
  gererClavierAccordeon(event) {
    if (event.key !== "Enter" && event.key !== " ") {
      return
    }
    event.preventDefault()
    this.panneauAmiDeplier = !this.panneauAmiDeplier
  }

  /**
   * @param {PointerEvent} event
   */
  modifierAffichageAccordeon(event) {
    if (event.composedPath().some((element) => element instanceof HTMLElement && element.tagName === "P-BOUTON-ICONE")) {
      return
    }
    this.panneauAmiDeplier = !this.panneauAmiDeplier
  }

  /**
   *
   * @param {Event} event
   */
  modifierAmi(event) {
    event.stopPropagation()
    this.dispatchEvent(
      new CustomEvent(EVENEMENT_MODIFIER_AMI, {
        bubbles: true,
        composed: true,
        detail: { id: this.id },
      }),
    )
  }

  ajouterMessage(event) {
    event.stopPropagation()

    this.dispatchEvent(
      new CustomEvent(EVENEMENT_AJOUTER_MESSAGE_A_UNE_CONVERSATION, {
        bubbles: true,
        composed: true,
        detail: { id: this.id },
      }),
    )
  }
}
customElements.define("p-ami", Ami)
